import { createReducer, getArrayAfterAsyncCall } from '@topconagriculture/frontend-utils';

import { addGroupType, deleteGroupType, editGroupType, getGroupTypeList } from './groupType.actions';
import { GroupType } from './groupType.types';

export type GroupTypeState = GroupType[];

export const initialState: GroupTypeState = [];

const groupTypeReducer = createReducer(initialState, {
  [getGroupTypeList.done.type]: (state: GroupTypeState, action: ReturnType<typeof getGroupTypeList.done>) =>
    getArrayAfterAsyncCall<GroupType>(state, action),
  [addGroupType.done.type]: (state: GroupTypeState, action: ReturnType<typeof addGroupType.done>) => {
    const groupType = action.payload.result;
    return [...state, groupType];
  },
  [editGroupType.done.type]: (state: GroupTypeState, action: ReturnType<typeof editGroupType.done>) => {
    const editedGroupType = action.payload.params.data;
    return state.map((groupType) => {
      if (groupType.id === editedGroupType.id) {
        return {
          ...groupType,
          ...editedGroupType,
        };
      }
      return groupType;
    });
  },
  [deleteGroupType.done.type]: (state: GroupTypeState, action: ReturnType<typeof deleteGroupType.done>) => {
    const groupTypeId = action.payload.params.id;
    return [...state.filter((groupType) => groupType.id !== groupTypeId)];
  },
});

export default groupTypeReducer;
